export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_ORDERS_PANEL':
      return { ...state, orders: action.orders };
    case 'CANCEL_ORDER': {
      const order = ((state.orders && state.orders.purchase) || []).find(o => o.id === action.orderId);
      if (order) order.status = 'canceled';
      return { ...state };
    }
    default:
      return state;
  }
};
